// extracted by mini-css-extract-plugin
export var articleLayout = "article-pagination-module--article-layout--0urHq";
export var article = "article-pagination-module--article--w+aHP";
export var postList = "article-pagination-module--post-list--Yx56l";
export var postContainer = "article-pagination-module--post-container--IPZF0";
export var postImage = "article-pagination-module--post-image--58Wu1";
export var postFade = "article-pagination-module--post-fade--c2nF1";
export var postText = "article-pagination-module--post-text--YGWql";